// @flow
import React, { useEffect } from "react";
import "./styles.css";
import * as sessionActionCreators from "../../action-creators/session-actions";
import * as modalActionCreators from "../../action-creators/modal-actions";
import { MAIN_SIDE_PANEL } from "../../constants/modals";
import PaginationControls from "../../components/pagination-controls";
import { CSSTransition } from "react-transition-group";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import IconButton from "../icon-button";

type PropsType = {
    actions: { [string]: any => void },
    pagination: boolean,
    modals?: Array<{ [string]: boolean }>,
    children: any,
    data: [],
    onRowSelect?: any => void,
    RowTemplate: any=>React$Element<any>,
    toolbar?: any=>React$Element<any>,
    headerContent: any=>React$Element<any>
};

const MyComponent = ({
                         actions,
                         pagination,
                         modals,
                         children,
                         data,
                         onRowSelect,
                         RowTemplate,
                         toolbar,
                         headerContent
                     }: PropsType) => {

    // TODO: Make this a ref
    const targetElement = document.querySelector("#targetElementId");

    useEffect(() => clearAllBodyScrollLocks, []);

    if (modals[MAIN_SIDE_PANEL]) {
        disableBodyScroll(targetElement);
    } else {
        enableBodyScroll(targetElement);
    }
    const rows = (data || []).map(datum => (
        <div
            className={ "page--row" }
            key={ datum.id || datum.uid }
            onClick={ () => {
                if (Boolean(onRowSelect)) {
                    onRowSelect(datum.id || datum.uid);
                } else {
                    actions.openModalExclusively(MAIN_SIDE_PANEL);
                }
            } }
            onKeyDown={ (event) => {
                if (event.code === 13) {
                    if (Boolean(onRowSelect)) {
                        onRowSelect(datum.id || datum.uid);
                    } else {
                        actions.openModalExclusively(MAIN_SIDE_PANEL);
                    }
                }
            } }
            role={ "button" }
            tabIndex={ 0 }
        >
            <RowTemplate { ...datum }/>
        </div>
    ));

    return (
        <CSSTransition classNames="fade"
                       timeout={ 300 }>
            <article className="page">
                <div className="page--summaries">
                    <div className={ "page--summaries-wrapper" }>
                        <header className="page--header">
                            <div className={ "page--header-container" }>
                                { toolbar }
                            </div>
                        </header>
                        <div className={ "page--rows" }>
                            { rows }
                        </div>
                        {
                            pagination
                                ? (
                                    <footer className="page--footer">
                                        <PaginationControls
                                            currentPage={ data.currentPage }
                                            from={ data.from }
                                            lastPage={ data.lastPage }
                                            perPage={ data.perPage }
                                            to={ data.to }
                                            total={ data.total }
                                        />
                                    </footer>)
                                : null
                        }
                    </div>
                </div>
                <div className={ `page--detail${ modals[MAIN_SIDE_PANEL] ? " is-visible" : "" }` }>
                    <div className={ "page--detail-header" }>
                        <span className={ "page--header-controls" }>{ headerContent }</span>
                        <IconButton
                            className={ "page--close-detail" }
                            onClick={ () => {
                                actions.closeModal(MAIN_SIDE_PANEL);
                            } }
                            title={ "Close" }
                            icon={ "faChevronRight" }
                            style={ { margin: "O auto" } }
                        />
                    </div>
                    <div className={ "page--scroll-area" }
                         id="targetElementId">
                        { children }
                    </div>
                </div>
            </article>
        </CSSTransition>
    );
};


const mapStateToProps = (state: Object): Object => {
    const user = (state.users || { data: {} }).data[state.session.user.uid] || { photoURL: state.session.user.photoURL };
    const modals = state.modals.data;
    return ({ user, modals });
};

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators({ ...sessionActionCreators, ...modalActionCreators }, dispatch)
});

export const Page = connect(mapStateToProps, mapDispatchToProps)(MyComponent);